export default "__VITE_ASSET__CFOLcImG__"